// Plural em pt-BR sem concatenar "s" no escuro.
//
// Nasceu em 11/08/2026 depois de eu escrever `mensagem${n === 1 ? '' : 's'}` em DOIS lugares
// e produzir **"30 mensagems"** nos dois — a segunda vez ja depois de ter corrigido a primeira.
// Palavra terminada em -m faz plural em -ns (mensagem/mensagens, homem/homens), e o idioma
// `${palavra}s` do resto do sistema nao avisa que errou: typecheck, teste e smoke passam
// verdes por cima de texto errado, e so aparece lendo a tela.
//
// Nao e um pluralizador completo de portugues (nem precisa ser): resolve as terminacoes que
// aparecem em rotulo de contagem. Caso irregular de verdade passa a forma plural a mao.

/** Plural de um substantivo simples em pt-BR. */
export function plural(palavra: string): string {
  const p = palavra.trim();
  if (!p) return p;

  // -ao tem tres plurais e nenhum default seguro (mao/maos, pao/paes, balao/baloes):
  // devolver um chute aqui seria trocar um erro visivel por um silencioso.
  // Quem tiver palavra em -ao passa o plural pronto pra `contar`.
  if (/[çc]ão$/i.test(p) || /ão$/i.test(p)) return `${p}s`;

  if (/m$/i.test(p)) return `${p.slice(0, -1)}ns`;           // mensagem -> mensagens
  if (/(r|z|s)$/i.test(p)) return /s$/i.test(p) ? p : `${p}es`; // mulher -> mulheres; lapis -> lapis
  if (/al$/i.test(p)) return `${p.slice(0, -2)}ais`;          // total -> totais
  if (/el$/i.test(p)) return `${p.slice(0, -2)}eis`;          // papel -> papeis
  if (/il$/i.test(p)) return `${p.slice(0, -2)}is`;           // funil -> funis
  if (/ol$/i.test(p)) return `${p.slice(0, -2)}ois`;          // farol -> farois
  if (/ul$/i.test(p)) return `${p.slice(0, -2)}uis`;          // paul -> pauis
  return `${p}s`;
}

/**
 * Rotulo de contagem: `contar(1, 'mensagem')` -> "1 mensagem";
 * `contar(30, 'mensagem')` -> "30 mensagens".
 * Passe `formaPlural` quando o plural for irregular.
 */
export function contar(n: number, singular: string, formaPlural?: string): string {
  return `${n} ${n === 1 ? singular : (formaPlural ?? plural(singular))}`;
}
